import React from 'react'
import { TextValidator } from '@/housefolios-components/shared/muiFormValidator'
import { VALIDATION_RULES } from '@/constants/validation'

const PhoneInput = ({ phoneNumber, setPhoneNumber  }) => {
  return (
    <TextValidator
      fullWidth={true}
      variant="outlined"
      placeholder="Phone Number"
      label="Phone Number"
      value={phoneNumber}
      onChange={(event) => setPhoneNumber(event.target.value)}
      validators={VALIDATION_RULES.phone.validators}
      errorMessages={VALIDATION_RULES.phone.errorMessages}
    />
  )
}

export default PhoneInput
